module.exports = __webpack_public_path__ + "static/media/Poppins-Light.5d7d7138.woff";